import './Aboutcontentstyle.css';
import mypic from '../images/mypic1.jpg'
import mypic2 from '../images/shitsama1.jpg'
import React from 'react'
import Resume from '../images/Tech2023cv.pdf'
import Coverletter from '../images/CoverLetter.pdf'
import styled, {keyframes} from 'styled-components';


const Aboutcontent = () => {
  return (
    <div className='About'>
        <div className='left'>
            <Header>
            So, Who Am I?
            </Header>
            <Footer>
            I am a software engineer, sound engineer, data-entry clerk and
music producer aiming to improve and modernize software
technology and sound digitally with the skills I have possessed
over the past 6 years.
            </Footer>
            
            <button className='Bbtn mt-3 mx-5'>
                <a className='text-white' href={Resume} download='ShitsamaJohn_Resume'>CV</a>
            </button>
            <button className='Bbtn mt-3 mx-5'>
                <a className='text-white' href={Coverletter} download='ShitsamaJohn_CoverLetter'>Cover Letter</a>
            </button>
            
        </div>
        <div className='right'>
            <div className='img-container'>
                <Fade className='img-stack'>
                    <img src={mypic} className='img' alt='true'/>
                </Fade>
                <Fade className='img-stacktwo'>
                    <img src={mypic2} className='img' alt='true'/>
                </Fade>
            </div>
        </div>
    </div>
  )
}
const textfade = keyframes `
from {
  opacity: 0;
  transform: translateX(200px);
}
to {
  opacity: 1;
  transform: translateY(0px);
}
`
;
const Footer = styled.p`
animation-name: ${textfade};
animation-duration: 4000ms;
`

// 
const textfader = keyframes `
from {
  opacity: 0;
  transform: translateX(-200px);
}
to {
  opacity: 1;
  transform: translateY(0px);
}
`
;
const Header = styled.h1`
animation-name: ${textfader};
animation-duration: 3000ms;
` 

//
const imgFader = keyframes `
from {
  opacity: 0;
  transform: translateX(600px);
}
to {
  opacity: 1;
  transform: translateY(0px);
}
`
;
const Fade = styled.div`
animation-name: ${imgFader};
animation-duration: 4000ms;
` 

export default Aboutcontent